/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobHistory_statusTypes$ref: FragmentReference;
declare export opaque type JobHistory_statusTypes$fragmentType: JobHistory_statusTypes$ref;
export type JobHistory_statusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: JobHistory_statusTypes$ref,
|};
export type JobHistory_statusTypes$data = JobHistory_statusTypes;
export type JobHistory_statusTypes$key = {
  +$data?: JobHistory_statusTypes$data,
  +$fragmentRefs: JobHistory_statusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "JobHistory_statusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4256ff761b880cb2582fe87b684af70c';
module.exports = node;
